// extracted by mini-css-extract-plugin
export default {"absolute":"absolute__Ye9pM","animation":"animation__HLr7X","fade":"fade__znxGJ"};